<section class="funcionamento">
    <div class="container">
        <div class="row d-flex justify-content-between align-items-center">
            <div class="col-lg-5 d-flex justify-content-start mb-4">
                <img src="{{ data.IMAGEM }}" class="img-fluid"/>
            </div>
            <div class="col-lg-6 offset-lg-1 text-left mb-4">
                <h3 class="mb-4">{{ data.TITULO }}</h3>
                <ul class="p-0">
                    <li *ngFor="let valor of data.VALORES">
                        <span class="badge badge-pill badge-primary mr-4">{{ valor.ORDEM}}</span> <span>{{ valor.DESCRICAO }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>